import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'


import Home from './Pages/Home';
import Features from './Pages/Features';
import PrivacyPolicy from './Pages/PrivacyPolicy';

import * as ROUTES from './Constants/routes';

// https://getbootstrap.com/docs/4.0/examples/cover/#
function App() {
  return (
    <Router>

        <div id="content-wrap">

          {/* <Navbar /> */}
          <div id="body">

            <Switch>
              {/* Authenticate Pages */}
              <Route exact path={ROUTES.HOME} component={Home} />
              <Route exact path={ROUTES.FEATURES} component={Features} />
              <Route path={ROUTES.PRIVACYPOLICY} component={PrivacyPolicy} />


            </Switch>
          </div>

        </div>
        {/* <Footer /> */}

      </Router>
  );
}

export default App;
